import React from 'react';
import { Box, Typography, Grid, Paper, Divider, Button, Card, CardContent, Chip } from '@mui/material';
import { usePDF } from 'react-to-pdf';
import { styled } from '@mui/system';
import { ReactComponent as Logo } from '../../img/rayo energy.svg';
// Importamos imagen de fondo (asegúrate de tener este archivo en la ruta correcta)
import FondoPortada from '../../img/pdf/paneles.webp';
import Img_Sufi from '../../img/pdf/Sufi.png';
import Img_Bogota from '../../img/pdf/banco_bogota.png';
import Img_REntek from '../../img/pdf/Img_REntek.png';
import Proyecto1 from '../../img/pdf/paneldos.jpg';
import Proyecto2 from '../../img/pdf/paneldos.jpg';
import Proyecto3 from '../../img/pdf/paneldos.jpg';
import Proyecto4 from '../../img/pdf/paneldos.jpg';
import Proyecto5 from '../../img/pdf/paneldos.jpg';
import Proyecto6 from '../../img/pdf/paneldos.jpg';
// Constantes para el PDF
const PAGE_WIDTH_MM = 200; // Ancho A4 en mm
const PAGE_HEIGHT_MM = 297; // Alto A4 en mm
const MM_TO_PX = 3.78; // Factor de conversión mm a px


// Componente para forzar saltos de página
const PageBreak = styled(Box)({
    '@media print': {
        pageBreakAfter: 'always',
        height: 0,
        visibility: 'hidden'
    }
});

// Colores corporativos actualizados
const colors = {
    dark: '#121212',
    primary: '#EBC848',
    light: '#FFFFFF',
    accent: '#1E1E1E',
    neonEffect: '0 0 10px #EBC848, 0 0 20px rgba(235, 200, 72, 0.7)',
    background: '#121212'
};


// Estilo base para páginas del PDF
const PdfPage = styled(Box)({
    width: `${PAGE_WIDTH_MM}mm`,
    minHeight: `${PAGE_HEIGHT_MM}mm`,
    backgroundColor: colors.background,
    color: colors.light,
    position: 'relative',
    overflow: 'hidden',
    padding: '15mm',
    boxSizing: 'border-box',
    '@media screen': {
        marginBottom: '20px',
        boxShadow: '0 0 10px rgba(0,0,0,0.5)'
    },
    '@media print': {
        padding: '10mm',
        margin: 0,
        overflow: 'visible'
    }
});

// Estilo para la portada especial
const PortadaPage = styled(PdfPage)({
    backgroundImage: FondoPortada,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media print': {
        height: `${PAGE_HEIGHT_MM}mm`,
        minHeight: `${PAGE_HEIGHT_MM}mm`
    }
});
// Estilos personalizados con efectos modernos
const CorporateHeader = styled(Paper)({
    backgroundImage: FondoPortada,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '350px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    color: colors.light,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(18, 18, 18, 0.85)'
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: '2px solid transparent',
        animation: 'borderPulse 6s infinite linear',
        pointerEvents: 'none'
    },
    '@keyframes borderPulse': {
        '0%': { borderColor: 'rgba(235, 200, 72, 0.1)' },
        '50%': { borderColor: 'rgba(235, 200, 72, 0.7)' },
        '100%': { borderColor: 'rgba(235, 200, 72, 0.1)' }
    },
    marginBottom: '40px' // Añadido para separación
});


const NeonCard = styled(Card)({
    background: colors.dark,
    color: colors.light,
    border: '1px solid rgba(235, 200, 72, 0.3)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: colors.neonEffect,
        '&::before': {
            opacity: 1
        }
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: colors.primary,
        opacity: 0.5,
        transition: 'opacity 0.3s ease'
    }
});

const ProcessStep = styled(Paper)({
    padding: '24px',
    background: `linear-gradient(135deg, ${colors.dark} 0%, #252525 100%)`,
    color: colors.light,
    borderLeft: `4px solid ${colors.primary}`,
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '-50%',
        left: '-50%',
        right: '-50%',
        bottom: '-50%',
        background: `linear-gradient(
            to bottom right,
            rgba(235, 200, 72, 0) 0%,
            rgba(235, 200, 72, 0.1) 30%,
            rgba(235, 200, 72, 0) 60%
        )`,
        transform: 'rotate(30deg)',
        animation: 'shine 3s infinite linear',
        pointerEvents: 'none'
    },
    '@keyframes shine': {
        '0%': { transform: 'rotate(30deg) translate(-30%, -30%)' },
        '100%': { transform: 'rotate(30deg) translate(30%, 30%)' }
    }
});

const PrecotizacionPDF = ({ data, onBack, Fondo }) => {
    const { toPDF, targetRef } = usePDF({
        filename: `precotizacion-solar-${data.nombre || 'cliente'}.pdf`,
        page: {
            margin: 0,
            format: [PAGE_WIDTH_MM, PAGE_HEIGHT_MM],
            orientation: 'portrait',
            background: colors.background
        },
        canvas: {
            scale: 3,
            useCORS: true,
            windowWidth: PAGE_WIDTH_MM * MM_TO_PX,
            windowHeight: PAGE_HEIGHT_MM * MM_TO_PX
        },
        overrides: {
            body: {
                margin: 0,
                padding: 0,
                backgroundColor: colors.background
            }
        }
    });
    Fondo = Fondo.Fondo;
    // Datos de ejemplo para bancos
    const bancos = [
        { nombre: 'SUFI', logo: Img_Sufi },
        { nombre: 'Banco De Bogota', logo: Img_Bogota },
        { nombre: 'REntek', logo: Img_REntek },
    ];



    //Datos de proyectos echos 

    const proyectos = [
        {
            nombre: "Residencial Solar - Bogotá",
            imagen: Proyecto1,
            descripcion: "Instalación de 12 paneles JA Solar con inversor Huawei para vivienda familiar",
            categoria: "RESIDENCIAL",
            detalles: {
                potencia: "4.8 kWp",
                ahorro: "70% en factura eléctrica",
                fecha: "Enero 2023"
            }
        },
        {
            nombre: "Comercial Solar - Medellín",
            imagen: Proyecto2,
            descripcion: "Sistema de 50kW para centro comercial con monitorización inteligente",
            categoria: "COMERCIAL",
            detalles: {
                potencia: "50 kWp",
                ahorro: "$3.2M mensuales",
                fecha: "Marzo 2023"
            }
        },
        {
            nombre: "Industrial Solar - Cali",
            imagen: Proyecto3,
            descripcion: "Granja solar de 200kW para fábrica textil con almacenamiento",
            categoria: "INDUSTRIAL",
            detalles: {
                potencia: "200 kWp",
                ahorro: "85% de consumo",
                fecha: "Junio 2023"
            }
        },
        {
            nombre: "Gobierno Solar - Barranquilla",
            imagen: Proyecto4,
            descripcion: "Techos solares para edificios públicos con inyección a red",
            categoria: "GUBERNAMENTAL",
            detalles: {
                potencia: "120 kWp",
                ahorro: "60% energía municipal",
                fecha: "Agosto 2023"
            }
        },
        {
            nombre: "Condominio Solar - Bucaramanga",
            imagen: Proyecto5,
            descripcion: "Sistema compartido para 20 unidades con medición neta",
            categoria: "CONDOMINIO",
            detalles: {
                potencia: "35 kWp",
                ahorro: "$2.5M mensuales",
                fecha: "Octubre 2023"
            }
        },
        {
            nombre: "Hotel Solar - Cartagena",
            imagen: Proyecto6,
            descripcion: "Sistema híbrido solar-térmico para hotel 5 estrellas",
            categoria: "HOTELERO",
            detalles: {
                potencia: "75 kWp",
                ahorro: "90% agua caliente",
                fecha: "Diciembre 2023"
            }
        }
    ];



    // Función para formatear moneda
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0
        }).format(value || 0);
    };

    // Función para calcular el Retorno de Inversión (ROI)
    const calcularROI = (valorProyecto, ahorroMensual) => {
        if (!valorProyecto || !ahorroMensual) return 'No calculado';

        const meses = Math.ceil(valorProyecto / ahorroMensual);
        const años = Math.floor(meses / 12);
        const mesesRestantes = meses % 12;

        if (años === 0) return `${meses} meses`;
        if (mesesRestantes === 0) return `${años} años`;
        return `${años} años y ${mesesRestantes} meses`;
    };

    // Datos simulados para la gráfica
    const datosGrafica = [
        { año: 0, valor: 0 },
        { año: 5, valor: data.ahorroMensual ? data.ahorroMensual * 12 * 5 : 10000000 },
        { año: 10, valor: data.ahorroMensual ? data.ahorroMensual * 12 * 10 : 20000000 },
        { año: 15, valor: data.ahorroMensual ? data.ahorroMensual * 12 * 15 : 30000000 },
        { año: 20, valor: data.ahorroMensual ? data.ahorroMensual * 12 * 20 : 40000000 },
        { año: 25, valor: data.ahorroMensual ? data.ahorroMensual * 12 * 25 : 50000000 }
    ];

    // Calcular puntos para la línea de la gráfica
    const calcularPuntosGrafica = () => {
        const maxValor = Math.max(...datosGrafica.map(item => item.valor));
        return datosGrafica.map(item => {
            const x = 10 + (item.año * (80 / 25));
            const y = 80 - (item.valor / maxValor * 60);
            return { x, y };
        });
    };

    const puntosGrafica = calcularPuntosGrafica();
    const puntosPath = puntosGrafica.map((punto, index) =>
        `${index === 0 ? 'M' : 'L'} ${punto.x}% ${punto.y}%`
    ).join(' ');

    // 1. Estilo optimizado para PDF
    const PortadaPDF = styled(Box)({
        width: '100%',
        height: '297mm', // Altura exacta de A4
        minHeight: '297mm', // Fuerza altura mínima
        position: 'relative',
        backgroundColor: colors.dark,
        overflow: 'hidden',
        pageBreakAfter: 'always', // Fuerza nueva página después
        '@media screen': {
            height: '100vh',
            marginBottom: '40px'
        }
    });


    return (


        <Box ref={targetRef} sx={{
            backgroundColor: colors.dark,
            color: colors.light,
            '& > *': {
                pageBreakInside: 'avoid'
            }
        }}>
            {/* PORTADA */}
            <PortadaPage>
                {/* Fondo con opacidad */}
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${FondoPortada})`,  // Usamos la imagen importada
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 0,
                    opacity: 0.85
                }} />

                {/* Contenido principal */}
                <Box sx={{
                    position: 'relative',
                    zIndex: 1,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: '20mm'
                }}>
                    {/* Encabezado */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start'
                    }}>
                        <Box>
                            <Typography variant="h2" sx={{
                                fontWeight: 'bold',
                                mb: 1,
                                color: colors.primary,
                                fontSize: '2.5rem'
                            }}>
                                ENERGÍA SOLAR
                            </Typography>
                            <Typography variant="h4" sx={{ color: colors.light }}>
                                SOLUCIONES INTELIGENTES
                            </Typography>
                        </Box>
                        <Box sx={{
                            width: '70mm',
                            height: '29mm',
                            position: 'absolute',
                            right: '15mm',
                            top: '15mm',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                            '& svg': {
                                width: '100%',
                                height: '100%',
                                fill: colors.primary  // Aseguramos que el logo tenga el color corporativo
                            }
                        }}>
                            <Logo />  {/* Usamos el componente SVG importado */}
                        </Box>
                    </Box>

                    {/* Pie de portada */}
                    <Box sx={{
                        backgroundColor: 'rgba(30, 30, 30, 0.9)',
                        borderTop: `2px solid ${colors.primary}`,
                        padding: '15mm',
                        marginBottom: '10mm'
                    }}>
                        <Typography variant="h3" sx={{
                            fontWeight: 'bold',
                            color: colors.primary,
                            fontSize: '2rem',
                            mb: '5mm'
                        }}>
                            PRECOTIZACIÓN PARA {data.nombre?.toUpperCase() || 'CLIENTE'}
                        </Typography>
                        <Typography variant="body1" sx={{
                            fontStyle: 'italic',
                            fontSize: '1rem'
                        }}>
                            "Ahora la energía solar está a tu altura"
                        </Typography>
                        <Typography variant="body2" sx={{
                            display: 'block',
                            mt: '5mm',
                            color: colors.primary
                        }}>
                            Fecha: {new Date().toLocaleDateString('es-CO', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </Typography>
                    </Box>
                </Box>
            </PortadaPage>


            <PdfPage>
                {/* Quiénes somos */}
                <Box sx={{
                    p: 6,
                    background: `linear-gradient(135deg, ${colors.dark} 0%, #1a1a1a 100%)`,
                    mt: 0, // Eliminamos margen superior
                    mb: 4,
                    position: 'relative',
                    overflow: 'hidden',
                    borderBottom: `1px solid ${colors.primary}`,
                    pageBreakAfter: 'avoid',
                    '@media print': {
                        p: 4 // Reducimos padding para impresión
                    }
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 4,
                        textAlign: 'center',
                        textShadow: colors.neonEffect,
                        position: 'relative'
                    }}>
                        <Box
                            component="span"
                            sx={{
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-10px',
                                width: '100px',
                                height: '3px',
                                background: colors.primary,
                                boxShadow: colors.neonEffect
                            }}
                        />
                        QUIÉNES SOMOS
                    </Typography>

                    <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" sx={{
                                color: colors.primary,
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box component="span" sx={{
                                    display: 'inline-block',
                                    width: '10px',
                                    height: '10px',
                                    backgroundColor: colors.primary,
                                    boxShadow: colors.neonEffect,
                                    mr: 2
                                }} />
                                NUESTRA MISIÓN
                            </Typography>
                            <Typography sx={{
                                color: colors.light,
                                lineHeight: '1.8',
                                fontSize: '1.1rem'
                            }}>
                                En <Box component="span" sx={{ color: colors.primary, fontWeight: 'bold' }}>Dymes Energy</Box>,
                                lideramos la transición energética en Colombia con sistemas solares fotovoltaicos de
                                última generación. Combinamos <Box component="span" sx={{ color: colors.primary }}>tecnología alemana</Box> con
                                ingeniería local para ofrecer soluciones a medida que maximizan tu ahorro y minimizan
                                tu huella de carbono.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" sx={{
                                color: colors.primary,
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box component="span" sx={{
                                    display: 'inline-block',
                                    width: '10px',
                                    height: '10px',
                                    backgroundColor: colors.primary,
                                    boxShadow: colors.neonEffect,
                                    mr: 2
                                }} />
                                POR QUÉ ELEGIRNOS
                            </Typography>
                            <Box component="ul" sx={{
                                pl: 0,
                                listStyleType: 'none'
                            }}>
                                {[
                                    "6 años de experiencia certificada",
                                    "Equipos con garantías extendidas",
                                    "Ingenieros especializados en RETIE",
                                    "Financiamiento con bancos aliados",
                                    "Soporte post-venta 24/7"
                                ].map((item, index) => (
                                    <Box component="li" key={index} sx={{
                                        mb: 2,
                                        display: 'flex',
                                        alignItems: 'flex-start'
                                    }}>
                                        <Box sx={{
                                            minWidth: '24px',
                                            height: '24px',
                                            background: colors.dark,
                                            border: `1px solid ${colors.primary}`,
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 2,
                                            mt: '2px'
                                        }}>
                                            <Box sx={{
                                                width: '8px',
                                                height: '8px',
                                                background: colors.primary,
                                                borderRadius: '50%',
                                                boxShadow: colors.neonEffect
                                            }} />
                                        </Box>
                                        <Typography sx={{
                                            color: colors.light,
                                            fontSize: '1.1rem'
                                        }}>
                                            {item}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PdfPage>
            <PdfPage>

                {/* Beneficios */}
                <Box sx={{
                    p: 6,
                    background: colors.accent,
                    my: 4,
                    borderBottom: `4px solid ${colors.primary}`
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            bottom: '-15px',
                            width: '80px',
                            height: '4px',
                            background: colors.primary
                        }
                    }}>
                        BENEFICIOS PARA {data.tipoPersona?.Nombre === 'Juridica' ? 'TU EMPRESA' : 'TU HOGAR'}
                    </Typography>

                    <Grid container spacing={4}>
                        {data.tipoPersona?.Nombre === 'Juridica' ? (
                            <>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                COMPETITIVIDAD
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Reduce hasta un 95% tus costos operativos fijos, mejorando
                                                significativamente tu margen de utilidad.
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                BENEFICIOS TRIBUTARIOS
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Deducción del 50% en renta, exclusión de IVA y depreciación
                                                acelerada de equipos.
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                RESPONSABILIDAD SOCIAL
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Mejora tu imagen corporativa y cumple con objetivos ESG
                                                (Ambientales, Sociales y de Gobernanza).
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                AHORRO GARANTIZADO
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Reduce tu factura eléctrica desde el primer mes, con ahorros
                                                promedio del 70-95% en tu consumo.
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                VALORIZACIÓN
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Incrementa el valor de tu propiedad hasta en un 4-6% según
                                                estudios del Laboratorio Nacional de Energía Renovable (NREL).
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <NeonCard>
                                        <CardContent sx={{ height: '100%' }}>
                                            <Typography variant="h5" sx={{
                                                color: colors.primary,
                                                mb: 2,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Box component="span" sx={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    background: colors.primary,
                                                    boxShadow: colors.neonEffect,
                                                    mr: 2,
                                                    borderRadius: '4px'
                                                }} />
                                                ENERGÍA LIMPIA
                                            </Typography>
                                            <Typography sx={{ color: colors.light }}>
                                                Contribuye al medio ambiente evitando la emisión de CO₂ equivalente
                                                a plantar {data.ahorroCO2 ? Math.round((data.ahorroCO2 * 1000) / 21.77) : 'varios'} árboles al año.
                                            </Typography>
                                        </CardContent>
                                    </NeonCard>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Box>
            </PdfPage>
            <PdfPage>

                {/* Comparación de consumo */}
                <Box sx={{
                    p: 6,
                    background: colors.dark,
                    my: 4,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: 'radial-gradient(circle at 10% 20%, rgba(235, 200, 72, 0.05) 0%, transparent 20%)',
                        pointerEvents: 'none'
                    }
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        textShadow: colors.neonEffect
                    }}>
                        <Box
                            component="span"
                            sx={{
                                display: 'inline-block',
                                padding: '0 20px 10px',
                                borderBottom: `3px solid ${colors.primary}`,
                                boxShadow: colors.neonEffect
                            }}
                        >
                            COMPARACIÓN DE CONSUMO
                        </Box>
                    </Typography>

                    <Box sx={{
                        background: '#252525',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                    }}>
                        <Box sx={{
                            background: colors.primary,
                            color: colors.dark,
                            p: '12px 20px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box>Concepto</Box>
                            <Box sx={{ display: 'flex', width: '40%', justifyContent: 'space-between' }}>
                                <Box sx={{ width: '50%', textAlign: 'right' }}>Mensual</Box>
                                <Box sx={{ width: '50%', textAlign: 'right' }}>Anual</Box>
                            </Box>
                        </Box>

                        {[
                            { concepto: 'Consumo Promedio (kWh)', mensual: data.consumoMensual || '7.793', anual: data.consumoAnual || '93.516' },
                            { concepto: 'Energía Generada SSFV (kWh)', mensual: data.generacionMensual || '9.529', anual: data.generacionAnual || '114.345' },
                            { concepto: 'Precio kWh Operador de Red', mensual: data.precioKWh ? formatCurrency(data.precioKWh) : '$905,0', anual: data.precioKWh ? formatCurrency(data.precioKWh) : '$905,0' },
                            { concepto: 'Ahorro esperado', mensual: data.ahorroMensual ? formatCurrency(data.ahorroMensual) : '$8.623.519', anual: data.ahorroAnual ? formatCurrency(data.ahorroAnual) : '$103.482.225', destacado: true },
                            { concepto: 'Cubrimiento del Consumo Promedio', mensual: data.cobertura ? `${data.cobertura}%` : '122,27%', anual: '' }
                        ].map((item, index) => (
                            <Box key={index} sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                p: '12px 20px',
                                borderBottom: '1px solid rgba(255,255,255,0.1)',
                                background: item.destacado ? 'rgba(235, 200, 72, 0.1)' : 'transparent',
                                fontWeight: item.destacado ? 'bold' : 'normal'
                            }}>
                                <Box sx={{ color: colors.light }}>{item.concepto}</Box>
                                <Box sx={{ display: 'flex', width: '40%', justifyContent: 'space-between' }}>
                                    <Box sx={{
                                        width: '50%',
                                        textAlign: 'right',
                                        color: item.destacado ? colors.primary : colors.light
                                    }}>
                                        {item.mensual}
                                    </Box>
                                    <Box sx={{
                                        width: '50%',
                                        textAlign: 'right',
                                        color: item.destacado ? colors.primary : colors.light
                                    }}>
                                        {item.anual}
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </PdfPage>
            <PdfPage>

                {/* Condiciones comerciales */}
                <Box sx={{
                    p: 6,
                    background: colors.accent,
                    my: 4,
                    position: 'relative'
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            bottom: '-15px',
                            width: '80px',
                            height: '4px',
                            background: colors.primary
                        }
                    }}>
                        CONDICIONES COMERCIALES
                    </Typography>

                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Paper sx={{
                                p: 4,
                                height: '100%',
                                background: colors.dark,
                                color: colors.light,
                                position: 'relative',
                                overflow: 'hidden',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '4px',
                                    height: '100%',
                                    background: colors.primary
                                }
                            }}>
                                <Typography variant="h5" sx={{
                                    color: colors.primary,
                                    mb: 3,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <Box component="span" sx={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        background: colors.primary,
                                        boxShadow: colors.neonEffect,
                                        mr: 2,
                                        borderRadius: '50%'
                                    }} />
                                    INCLUSIONES
                                </Typography>

                                <Box component="ul" sx={{ pl: 0 }}>
                                    {[
                                        "Ja Solar, Jinko Solar o Trina Solar con garantías de aproximadamente 30 años",
                                        "Certificación RETIE completa",
                                        "Ingeniería de detalle firmada por profesional certificado",
                                        "Trámite ante operador de red",
                                        "Cambio a medidor bidireccional",
                                        "Gestión de beneficios tributarios UPME"
                                    ].map((item, index) => (
                                        <Box component="li" key={index} sx={{
                                            mb: 2,
                                            display: 'flex',
                                            alignItems: 'flex-start'
                                        }}>
                                            <Box sx={{
                                                minWidth: '24px',
                                                height: '24px',
                                                background: 'rgba(235, 200, 72, 0.1)',
                                                border: `1px solid ${colors.primary}`,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 2,
                                                mt: '2px'
                                            }}>
                                                <Box sx={{
                                                    width: '8px',
                                                    height: '8px',
                                                    background: colors.primary,
                                                    borderRadius: '50%',
                                                    boxShadow: colors.neonEffect
                                                }} />
                                            </Box>
                                            <Typography>{item}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper sx={{
                                p: 4,
                                height: '100%',
                                background: colors.dark,
                                color: colors.light,
                                position: 'relative',
                                overflow: 'hidden',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '4px',
                                    height: '100%',
                                    background: colors.primary
                                }
                            }}>
                                <Typography variant="h5" sx={{
                                    color: colors.primary,
                                    mb: 3,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <Box component="span" sx={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        background: colors.primary,
                                        boxShadow: colors.neonEffect,
                                        mr: 2,
                                        borderRadius: '50%'
                                    }} />
                                    REQUISITOS
                                </Typography>

                                <Box component="ul" sx={{ pl: 0 }}>
                                    {[
                                        "Punto de datos y medidor de energía cerca de los inversores",
                                        "Espacio para tableros eléctricos",
                                        "Acceso seguro al techo para instalación",
                                        "Documentación propiedad (para personas jurídicas)",
                                        "Última factura de energía"
                                    ].map((item, index) => (
                                        <Box component="li" key={index} sx={{
                                            mb: 2,
                                            display: 'flex',
                                            alignItems: 'flex-start'
                                        }}>
                                            <Box sx={{
                                                minWidth: '24px',
                                                height: '24px',
                                                background: 'rgba(235, 200, 72, 0.1)',
                                                border: `1px solid ${colors.primary}`,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 2,
                                                mt: '2px'
                                            }}>
                                                <Box sx={{
                                                    width: '8px',
                                                    height: '8px',
                                                    background: colors.primary,
                                                    borderRadius: '50%',
                                                    boxShadow: colors.neonEffect
                                                }} />
                                            </Box>
                                            <Typography>{item}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>


                </Box>
            </PdfPage>
            <PdfPage>

                {/* Análisis financiero con gráfica */}

                <Typography variant="h3" sx={{
                    color: colors.primary,
                    fontWeight: 'bold',
                    mb: 6,
                    textAlign: 'center',
                    textShadow: colors.neonEffect
                }}>
                    ANÁLISIS FINANCIERO
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Box sx={{
                            p: 3,
                            height: '100%',
                            border: `1px solid ${colors.primary}`,
                            borderRadius: '8px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="h5" sx={{ color: colors.primary, mb: 1 }}>
                                Inversión Total
                            </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                                {data.totalProyecto ? formatCurrency(data.totalProyecto) : 'Calculando...'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={{
                            p: 3,
                            height: '100%',
                            border: `1px solid ${colors.primary}`,
                            borderRadius: '8px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="h5" sx={{ color: colors.primary, mb: 1 }}>
                                Retorno (ROI)
                            </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                                {calcularROI(data.totalProyecto, data.ahorroMensual)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={{
                            p: 3,
                            height: '100%',
                            border: `1px solid ${colors.primary}`,
                            borderRadius: '8px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="h5" sx={{ color: colors.primary, mb: 1 }}>
                                Ahorro 25 años
                            </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                                {data.ahorroMensual ? formatCurrency(data.ahorroMensual * 12 * 25) : 'Calculando...'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </PdfPage>
            <PdfPage>
                {/* Gráfica de proyección */}
                <Box sx={{
                    mt: 6,
                    p: 4,
                    background: '#252525',
                    borderRadius: '8px',
                    position: 'relative',
                    overflow: 'hidden',
                    border: `1px solid ${colors.primary}`
                }}>
                    <Typography variant="h5" sx={{
                        color: colors.primary,
                        mb: 3,
                        textAlign: 'center'
                    }}>
                        PROYECCIÓN DE AHORROS
                    </Typography>

                    {/* Gráfica SVG interactiva */}
                    <Box sx={{
                        height: '300px',
                        position: 'relative',
                        background: colors.dark,
                        border: `1px solid ${colors.primary}`
                    }}>
                        <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
                            {/* Eje Y */}
                            <line x1="10" y1="20" x2="10" y2="80" stroke={colors.primary} strokeWidth="0.5" />

                            {/* Eje X */}
                            <line x1="10" y1="80" x2="90" y2="80" stroke={colors.primary} strokeWidth="0.5" />

                            {/* Líneas de guía horizontales */}
                            {[20, 40, 60, 80].map((y, index) => (
                                <line
                                    key={`guide-${index}`}
                                    x1="10"
                                    y1={100 - y}
                                    x2="90"
                                    y2={100 - y}
                                    stroke="rgba(235, 200, 72, 0.1)"
                                    strokeWidth="0.3"
                                />
                            ))}

                            {/* Línea de tendencia */}
                            <path
                                d={puntosPath}
                                fill="none"
                                stroke={colors.primary}
                                strokeWidth="2"
                                strokeLinejoin="round"
                            />

                            {/* Puntos de datos */}
                            {puntosGrafica.map((punto, index) => (
                                <circle
                                    key={`point-${index}`}
                                    cx={`${punto.x}%`}
                                    cy={`${punto.y}%`}
                                    r="1.5"
                                    fill={colors.primary}
                                    stroke={colors.dark}
                                    strokeWidth="0.5"
                                />
                            ))}

                            {/* Etiquetas eje Y */}
                            <text x="8" y="20" fill={colors.primary} fontSize="3" textAnchor="end" dominantBaseline="middle">
                                {data.ahorroMensual ? formatCurrency(data.ahorroMensual * 12 * 25) : '$XXX'}
                            </text>
                            <text x="8" y="80" fill={colors.primary} fontSize="3" textAnchor="end" dominantBaseline="middle">
                                0
                            </text>

                            {/* Etiquetas eje X */}
                            {[0, 5, 10, 15, 20, 25].map((year, index) => {
                                const x = 10 + (year * (80 / 25));
                                return (
                                    <text
                                        key={`year-${index}`}
                                        x={x}
                                        y="85"
                                        fill={colors.primary}
                                        fontSize="3"
                                        textAnchor="middle"
                                    >
                                        {year}a
                                    </text>
                                );
                            })}
                        </svg>
                    </Box>

                    {/* Leyenda */}
                    <Box sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Box sx={{
                            width: '20px',
                            height: '3px',
                            background: colors.primary,
                            mr: 2,
                            boxShadow: colors.neonEffect
                        }} />
                        <Typography variant="body2">
                            Proyección de ahorro acumulado a 25 años
                        </Typography>
                    </Box>
                </Box>

            </PdfPage>
            <PdfPage>
                {/* Financiamiento con logos de bancos */}

                {/* Financiamiento con logos de bancos */}
                <Box sx={{
                    p: 6,
                    background: colors.accent,
                    my: 4
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            bottom: '-15px',
                            width: '80px',
                            height: '4px',
                            background: colors.primary
                        }
                    }}>
                        ALIADOS FINANCIEROS
                    </Typography>

                    <Typography sx={{
                        textAlign: 'center',
                        mb: 4,
                        fontSize: '1.1rem',
                        color: colors.light
                    }}>
                        Trabajamos con las principales entidades financieras del país para ofrecerte las mejores condiciones
                    </Typography>

                    <Grid container spacing={4} sx={{ mb: 4, justifyContent: 'center' }}>
                        {bancos.map((banco, index) => (
                            <Grid item xs={6} sm={4} md={3} key={index} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: 120,
                                    height: 120,
                                    borderRadius: '50%',
                                    backgroundColor: colors.light,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    p: 2,
                                    mb: 2,
                                    border: `2px solid ${colors.primary}`,
                                    overflow: 'hidden',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                        transition: 'all 0.3s ease',
                                        boxShadow: `0 0 15px ${colors.primary}`
                                    }
                                }}>
                                    <Box sx={{
                                        width: '80%',
                                        height: '80%',
                                        backgroundImage: `url(${banco.logo})`,
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        filter: 'grayscale(100%)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            filter: 'grayscale(0%)'
                                        }
                                    }} />
                                </Box>
                                <Typography variant="body2" sx={{
                                    textAlign: 'center',
                                    color: colors.light,
                                    fontWeight: 'bold'
                                }}>
                                    {banco.nombre}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                    <Typography variant="h5" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 4,
                        textAlign: 'center'
                    }}>
                        OPCIONES DE PAGO
                    </Typography>

                    <Grid container spacing={4} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        {/* Hexágono 1 - Crédito Directo */}
                        <Grid item xs={12} md={4} sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box sx={{
                                position: 'relative',
                                width: 200,
                                height: 230,
                                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                                backgroundColor: colors.dark,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: `2px solid ${colors.primary}`,
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: `0 0 20px ${colors.primary}`,
                                    transition: 'all 0.3s ease'
                                }
                            }}>
                                <Typography variant="h6" sx={{
                                    color: colors.primary,
                                    mb: 2,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    px: 2
                                }}>
                                    Crédito Directo
                                </Typography>
                                <Typography sx={{
                                    color: colors.light,
                                    textAlign: 'center',
                                    px: 3
                                }}>
                                    Hasta 60 meses.
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Hexágono 2 - Leasing */}
                        <Grid item xs={12} md={4} sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box sx={{
                                position: 'relative',
                                width: 200,
                                height: 230,
                                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                                backgroundColor: colors.dark,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: `2px solid ${colors.primary}`,
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: `0 0 20px ${colors.primary}`,
                                    transition: 'all 0.3s ease'
                                }
                            }}>
                                <Typography variant="h6" sx={{
                                    color: colors.primary,
                                    mb: 2,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    px: 2
                                }}>
                                    Leasing
                                </Typography>
                                <Typography sx={{
                                    color: colors.light,
                                    textAlign: 'center',
                                    px: 3
                                }}>
                                    Opción de compra con cuotas deducibles
                                </Typography>
                            </Box>
                        </Grid>    {/* Hexágono 2 - Leasing */}
                        <Grid item xs={12} md={4} sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box sx={{
                                position: 'relative',
                                width: 200,
                                height: 230,
                                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                                backgroundColor: colors.dark,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: `2px solid ${colors.primary}`,
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: `0 0 20px ${colors.primary}`,
                                    transition: 'all 0.3s ease'
                                }
                            }}>
                                <Typography variant="h6" sx={{
                                    color: colors.primary,
                                    mb: 2,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    px: 2
                                }}>
                                    renting
                                </Typography>
                                <Typography sx={{
                                    color: colors.light,
                                    textAlign: 'center',
                                    px: 3
                                }}>
                                    sobre activos, deducibles el 100%                                </Typography>
                            </Box>
                        </Grid>

                        {/* Hexágono 3 - Pago Contado */}
                        <Grid item xs={12} md={4} sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box sx={{
                                position: 'relative',
                                width: 200,
                                height: 230,
                                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                                backgroundColor: colors.dark,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: `2px solid ${colors.primary}`,
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: `0 0 20px ${colors.primary}`,
                                    transition: 'all 0.3s ease'
                                }
                            }}>
                                <Typography variant="h6" sx={{
                                    color: colors.primary,
                                    mb: 2,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    px: 2
                                }}>
                                    Pago Contado
                                </Typography>
                                <Typography sx={{
                                    color: colors.light,
                                    textAlign: 'center',
                                    px: 3
                                }}>
                                    5% de descuento por pago completo anticipado
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

            </PdfPage>
            <PdfPage>
                {/* Proceso de instalación */}
                <Box sx={{
                    p: 6,
                    background: colors.dark,
                    my: 4,
                    position: 'relative',
                    overflow: 'hidden',
                    borderTop: `1px solid ${colors.primary}`,
                    borderBottom: `1px solid ${colors.primary}`
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        textShadow: colors.neonEffect
                    }}>
                        NUESTRO PROCESO
                    </Typography>

                    <Grid container spacing={4}>
                        {[
                            {
                                titulo: "01. INSTALACIÓN",
                                descripcion: "Nuestro equipo técnico realiza la instalación de los paneles, inversores y estructura.",
                                tiempo: "2-6 semanas según tamaño del proyecto",
                                icono: "🔧"
                            },
                            {
                                titulo: "02. CERTIFICACIÓN RETIE",
                                descripcion: "Realizamos todas las pruebas y certificaciones requeridas por el reglamento técnico.",
                                tiempo: "1 semana después de instalación",
                                icono: "📋"
                            },
                            {
                                titulo: "03. CONEXIÓN A RED",
                                descripcion: "Gestionamos con el operador de red la conexión de tu sistema solar fotovoltaico.",
                                tiempo: "45 días hábiles aprox.",
                                icono: "🔌"
                            }
                        ].map((paso, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <ProcessStep>
                                    <Box sx={{
                                        position: 'absolute',
                                        top: '20px',
                                        right: '20px',
                                        width: '40px',
                                        height: '40px',
                                        background: colors.primary,
                                        color: colors.dark,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold'
                                    }}>
                                        {paso.icono}
                                    </Box>
                                    <Typography variant="h5" sx={{
                                        color: colors.primary,
                                        mb: 2,
                                        pr: '50px'
                                    }}>
                                        {paso.titulo}
                                    </Typography>
                                    <Typography sx={{ mb: 2 }}>
                                        {paso.descripcion}
                                    </Typography>
                                    <Typography sx={{
                                        color: colors.primary,
                                        fontSize: '0.9rem',
                                        fontStyle: 'italic'
                                    }}>
                                        ⏱️ {paso.tiempo}
                                    </Typography>
                                </ProcessStep>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </PdfPage>
            <PdfPage>
                {/* Nuestros proyectos - Sección corregida */}

                <Box sx={{
                    p: 6,
                    background: colors.accent,
                    my: 4,
                    position: 'relative'
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            bottom: '-15px',
                            width: '80px',
                            height: '4px',
                            background: colors.primary
                        }
                    }}>
                        PROYECTOS RECIENTES
                    </Typography>

                    <Typography sx={{
                        textAlign: 'center',
                        mb: 4,
                        fontSize: '1.1rem',
                        color: colors.light
                    }}>
                        Más de 500 proyectos ejecutados con los más altos estándares de calidad
                    </Typography>

                    <Grid container spacing={4} sx={{
                        display: 'flex',
                        justifyContent: 'center', // Centra las columnas del grid
                        alignItems: 'stretch' // Asegura que todas las cards tengan la misma altura
                    }}>
                        {proyectos.map((proyecto, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index} sx={{
                                display: 'flex',
                                justifyContent: 'center', // Centra la card horizontalmente
                                transition: 'all 0.3s ease',
                                maxWidth: '100%', // Evita que las cards se expandan demasiado
                                '&:hover': {
                                    transform: 'translateY(-5px)'
                                }
                            }}>
                                <Card sx={{
                                    width: '100%',
                                    maxWidth: 380, // Ancho máximo para las cards
                                    height: '100%', // Toma toda la altura disponible
                                    minHeight: 400, // Altura mínima garantizada
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderRadius: '12px',
                                    boxShadow: 3,
                                    '&:hover': {
                                        boxShadow: `0 10px 25px rgba(235, 200, 72, 0.4)`,
                                        '& .project-image': {
                                            transform: 'scale(1.05)'
                                        },
                                        '& .project-overlay': {
                                            opacity: 1,
                                            background: `linear-gradient(to top, ${colors.dark} 30%, transparent 100%)`
                                        }
                                    }
                                }}>
                                    {/* Imagen del proyecto */}
                                    <Box
                                        component="img"
                                        src={proyecto.imagen}
                                        alt={proyecto.nombre}
                                        className="project-image"
                                        sx={{
                                            width: '100%',
                                            height: '200px', // Altura fija para la imagen
                                            objectFit: 'cover',
                                            transition: 'transform 0.5s ease'
                                        }}
                                    />

                                    {/* Contenido de la card */}
                                    <Box sx={{
                                        flex: 1, // Toma el espacio restante
                                        display: 'flex',
                                        flexDirection: 'column',
                                        p: 3,
                                        background: colors.dark
                                    }}>
                                        <Typography variant="h5" sx={{
                                            color: colors.primary,
                                            fontWeight: 'bold',
                                            mb: 1,
                                            textShadow: '0 1px 3px rgba(0,0,0,0.6)'
                                        }}>
                                            {proyecto.nombre}
                                        </Typography>

                                        <Typography variant="body1" sx={{
                                            mb: 2,
                                            flexGrow: 1, // Empuja el contenido hacia arriba
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                                        }}>
                                            {proyecto.descripcion}
                                        </Typography>

                                        {/* Detalles técnicos */}
                                        <Box sx={{
                                            display: 'flex',
                                            gap: 1,
                                            flexWrap: 'wrap',
                                            mb: 2
                                        }}>
                                            <Chip
                                                label={`${proyecto.detalles.potencia}`}
                                                size="small"
                                                sx={{
                                                    bgcolor: 'rgba(235, 200, 72, 0.2)',
                                                    color: colors.primary,
                                                    fontWeight: 'bold'
                                                }}
                                            />
                                            <Chip
                                                label={`Ahorro: ${proyecto.detalles.ahorro}`}
                                                size="small"
                                                sx={{
                                                    bgcolor: 'rgba(30, 30, 30, 0.7)',
                                                    color: colors.light,
                                                    border: `1px solid ${colors.primary}`
                                                }}
                                            />
                                        </Box>

                                        {/* Botón - Ahora perfectamente alineado */}
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            sx={{
                                                color: colors.primary,
                                                borderColor: colors.primary,
                                                mt: 'auto', // Empuja el botón hacia abajo
                                                '&:hover': {
                                                    bgcolor: 'rgba(235, 200, 72, 0.1)'
                                                }
                                            }}
                                        >
                                            Ver proyecto
                                        </Button>
                                    </Box>

                                    {/* Badge de categoría */}
                                    <Chip
                                        label={proyecto.categoria}
                                        sx={{
                                            position: 'absolute',
                                            top: 16,
                                            right: 16,
                                            bgcolor: colors.primary,
                                            color: colors.dark,
                                            fontWeight: 'bold',
                                            fontSize: '0.75rem',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                            zIndex: 2
                                        }}
                                    />
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

            </PdfPage>
            <PdfPage>
                {/* Contacto */}
                <Box sx={{
                    p: 6,
                    background: `linear-gradient(135deg, ${colors.dark} 0%, #1a1a1a 100%)`,
                    color: colors.light,
                    position: 'relative',
                    overflow: 'hidden',
                    borderTop: `1px solid ${colors.primary}`
                }}>
                    <Typography variant="h3" sx={{
                        color: colors.primary,
                        fontWeight: 'bold',
                        mb: 6,
                        textAlign: 'center',
                        textShadow: colors.neonEffect
                    }}>
                        CONTÁCTANOS
                    </Typography>

                    <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" sx={{
                                color: colors.primary,
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box component="span" sx={{
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    background: colors.primary,
                                    boxShadow: colors.neonEffect,
                                    mr: 2,
                                    borderRadius: '50%'
                                }} />
                                INFORMACIÓN DE CONTACTO
                            </Typography>

                            <Box sx={{ mb: 3 }}>
                                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Box component="span" sx={{ mr: 2, color: colors.primary }}>📍</Box>
                                    Carrera 10 n 10b 01, Villavicencio
                                </Typography>

                                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Box component="span" sx={{ mr: 2, color: colors.primary }}>📱</Box>
                                    +57 315 4340012
                                    ~Dymes Energy S.A.S                                </Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Box component="span" sx={{ mr: 2, color: colors.primary }}>✉️</Box>
                                    info@DymesEnergy.com.co
                                </Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component="span" sx={{ mr: 2, color: colors.primary }}>🌐</Box>
                                    www.DymesEnergy.com.co
                                </Typography>
                            </Box>

                            <Typography variant="h5" sx={{
                                color: colors.primary,
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box component="span" sx={{
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    background: colors.primary,
                                    boxShadow: colors.neonEffect,
                                    mr: 2,
                                    borderRadius: '50%'
                                }} />
                                HORARIO DE ATENCIÓN
                            </Typography>
                            <Typography>Lunes a Viernes: 8:00 AM - 6:00 PM</Typography>
                            <Typography>Sábados: 9:00 AM - 1:00 PM</Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" sx={{
                                color: colors.primary,
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box component="span" sx={{
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    background: colors.primary,
                                    boxShadow: colors.neonEffect,
                                    mr: 2,
                                    borderRadius: '50%'
                                }} />
                                ASESOR COMERCIAL
                            </Typography>

                            <Box sx={{
                                p: 3,
                                background: 'rgba(235, 200, 72, 0.1)',
                                borderLeft: `4px solid ${colors.primary}`,
                                mb: 3
                            }}>
                                <Typography variant="h6" sx={{ color: colors.primary }}>
                                    {data.asesor || 'DymesEnergy'}
                                </Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Box component="span" sx={{ mr: 2 }}>📞</Box>
                                    +57 315 4340012                                </Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component="span" sx={{ mr: 2 }}>✉️</Box>
                                    contacto@DymesEnergy.com.co
                                </Typography>
                            </Box>

                            <Typography sx={{ fontStyle: 'italic', mb: 3 }}>
                                "Estoy para resolver todas tus dudas y guiarte en el proceso de transición a energía solar"
                            </Typography>

                            <Button
                                variant="contained"
                                sx={{
                                    background: colors.primary,
                                    color: colors.dark,
                                    fontWeight: 'bold',
                                    py: '12px',
                                    px: '24px',
                                    '&:hover': {
                                        background: '#E0B845',
                                        boxShadow: colors.neonEffect
                                    }
                                }}
                            >
                                AGENDAR VISITA TÉCNICA
                            </Button>
                        </Grid>
                    </Grid>

                    <Typography variant="body2" sx={{
                        mt: 6,
                        textAlign: 'center',
                        fontStyle: 'italic',
                        color: colors.primary
                    }}>
                        Esta precotización es válida por 30 días a partir de la fecha de emisión.
                        Los valores finales están sujetos a una visita técnica de medición.
                    </Typography>
                </Box>
            </PdfPage>
            {/* Botones de acción */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                mt: 4,
                p: 4,
                background: colors.dark,
                borderTop: `1px solid ${colors.primary}`
            }}>
                <Button
                    variant="outlined"
                    onClick={onBack}
                    sx={{
                        mr: 2,
                        color: colors.primary,
                        borderColor: colors.primary,
                        '&:hover': {
                            borderColor: colors.primary,
                            background: 'rgba(235, 200, 72, 0.1)'
                        }
                    }}
                >
                    VOLVER
                </Button>
                <Box>
                    <Button
                        variant="contained"
                        onClick={() => toPDF()}
                        sx={{
                            background: colors.primary,
                            color: colors.dark,
                            fontWeight: 'bold',
                            py: '12px',
                            px: '24px',
                            mr: 2,
                            '&:hover': {
                                background: '#E0B845',
                                boxShadow: colors.neonEffect
                            }
                        }}
                    >
                        DESCARGAR PDF
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            background: colors.light,
                            color: colors.dark,
                            fontWeight: 'bold',
                            py: '12px',
                            px: '24px',
                            '&:hover': {
                                background: '#FFFFFF',
                                boxShadow: `0 0 10px ${colors.light}`
                            }
                        }}
                    >
                        IMPRIMIR COTIZACIÓN
                    </Button>
                </Box>
            </Box>
        </Box >
    );
};

export default PrecotizacionPDF;